import React from "react";

/**
 * Apply YGALAAD-style gradient to text (same as Building the future titles:
 * INNOVATION, EXPERTISE, MISSION, SOLUTIONS).
 * First letter: cyan/blue, middle: purple/pink, last two: pink/orange/yellow.
 */
export function applyGradientStyle(text) {
  if (!text || text.length === 0) return text;
  const upperText = String(text).toUpperCase();
  if (upperText.length === 1) {
    return <span className="gradient-text-y">{upperText}</span>;
  }
  if (upperText.length === 2) {
    return (
      <>
        <span className="gradient-text-y">{upperText[0]}</span>
        <span className="gradient-text-accent">{upperText[1]}</span>
      </>
    );
  }
  const firstLetter = upperText[0];
  const lastTwo = upperText.slice(-2);
  const middle = upperText.slice(1, -2);

  return (
    <>
      <span className="gradient-text-y">{firstLetter}</span>
      {middle && <span className="gradient-text">{middle}</span>}
      <span className="gradient-text-accent">{lastTwo}</span>
    </>
  );
}
